export default "__VITE_ASSET__CSN99JLR__"